export default class LocationSearchEventBus {
  constructor() {
    this.events = {};
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  emit(event, data = null) {
    if (this.events[event]) {
      this.events[event].forEach((callback) => callback(data));
    }
  }
}